export function latestPromise<T extends (...args: any[]) => Promise<any>>(func: T) {
  let latestCallId = 0;

  return ((...args: Parameters<T>): ReturnType<T> => {
    latestCallId += 1;
    const currentCallId = latestCallId;
    return new Promise((resolve, reject) => {
      func(...args)
        .then((result) => {
          if (currentCallId === latestCallId) {
            resolve(result);
          }
        })
        .catch((error) => {
          if (currentCallId === latestCallId) {
            reject(error);
          }
        });
    }) as ReturnType<T>;
  });
}
